<gc-modal
  [headerTitle]="'selectSpanMode.helpModal.title' | translate"
  [width]="'fullscreen'"
  [headerIcon]="'circleQuestion'"
  (closeModal)="closeModal()"
>
  <div class="modal-content">
    <section>
      <gc-text [variant]="'minorHeading'">{{
        'selectSpanMode.helpModal.spanColorGuide.title' | translate
      }}</gc-text>
      <app-span-color-guide [data]="spanColorGuideData" />
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">{{
        'selectSpanMode.helpModal.addingSpans.title' | translate
      }}</gc-text>
      <gc-text [variant]="'paragraph'">{{
        'selectSpanMode.helpModal.addingSpans.body' | translate
      }}</gc-text>
      <img
        [src]="'assets/guides/multi-span-selected-spans.png'"
        alt="Selected spans example"
      />
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">{{
        'selectSpanMode.helpModal.removingSpans.title' | translate
      }}</gc-text>
      <gc-text [variant]="'paragraph'">{{
        'selectSpanMode.helpModal.removingSpans.body' | translate
      }}</gc-text>
    </section>
    <section>
      <gc-text [variant]="'minorHeading'">{{
        'selectSpanMode.helpModal.spansNotAllowedForSelection.title' | translate
      }}</gc-text>
      <gc-text [variant]="'paragraph'">{{
        'selectSpanMode.helpModal.spansNotAllowedForSelection.body' | translate
      }}</gc-text>
      <img
        [src]="'assets/guides/multi-span-spans-with-existing-report.png'"
        alt="Spans with already existing on other report example"
      />
    </section>
  </div>
</gc-modal>
